import { Facebook, Github, Linkedin, Phone } from 'lucide-react';
import type { User } from '../types';
import { cn } from './ui/utils';
import { getUserContactLinks } from '../utils/userProfile';

type UserContactFields = Pick<User, 'phoneNumber' | 'linkedinUrl' | 'githubUrl' | 'facebookUrl'>;

interface UserContactLinksProps {
  user: UserContactFields;
  className?: string;
  linkClassName?: string;
}

const ICONS = {
  phone: Phone,
  linkedin: Linkedin,
  github: Github,
  facebook: Facebook,
} as const;

export function UserContactLinks({ user, className, linkClassName }: UserContactLinksProps) {
  const links = getUserContactLinks(user);

  if (!links.length) {
    return null;
  }

  return (
    <div className={cn('flex flex-wrap items-center gap-3 text-xs', className)}>
      {links.map((link) => {
        const Icon = ICONS[link.key];

        return (
          <a
            key={`${link.key}-${link.href}`}
            href={link.href}
            target={link.key === 'phone' ? undefined : '_blank'}
            rel={link.key === 'phone' ? undefined : 'noreferrer'}
            className={cn('inline-flex items-center gap-1 text-primary hover:underline', linkClassName)}
          >
            <Icon className="h-3 w-3" />
            {link.label}
          </a>
        );
      })}
    </div>
  );
}

export default UserContactLinks;